// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { getApiUrl } from "utils";
import { API_URL } from "constants/api";

type BlockTxsParams = {
  offset: number;
  limit: number;
  number: number | string;
};
// Define a service using a base URL and expected endpoints
export const blockApi = createApi({
  reducerPath: "blocks",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    getBlockList: builder.query<any, { offset: number; limit: number }>({
      query: ({ offset, limit }) =>
        `block/lastest?offset=${offset}&limit=${limit}`,
      keepUnusedDataFor: 0,
    }),
    getBlockByNumber: builder.query<any, string>({
      query: (blockNumber) => `block/?number=${blockNumber}`,
    }),
    getTxsOfBlockByNumber: builder.query<any, BlockTxsParams>({
      query: ({ number, offset, limit }) =>
        `block/transaction?number=${number}&offset=${offset}&size=${limit}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetBlockListQuery,
  useGetTxsOfBlockByNumberQuery,
  useGetBlockByNumberQuery,
} = blockApi;
